export default __webpack_public_path__ + "cef7936b87c0837df71a9ab525d7afe0.svg";